import { getNestedProperty, getFrontImage } from '@grandvisionhq/utils';

function getProductImageUrl(suggestion, isBynderImagesEnabled = false, staticsUrl = '') {
    var ref;
    if (isBynderImagesEnabled) {
        const images = getNestedProperty(suggestion, 'masterVariant.media.images', []);
        const imageUrl = getFrontImage(images).url;
        return `${imageUrl}?w=75&auto=format`;
    }
    const images = getNestedProperty(suggestion, 'masterVariant.images', []);
    var ref1;
    const imageUrl = (ref1 = (ref = images[0]) === null || ref === void 0 ? void 0 : ref.url) !== null && ref1 !== void 0 ? ref1 : '';
    return imageUrl && `${staticsUrl}${imageUrl}?w=75&auto=format`;
}

export { getProductImageUrl };
//# sourceMappingURL=getProductImageUrl.js.map
